<h2>Walletron Users</h2>

 <div class="grid">
    <div class="col-7">
        <div *ngIf="envRegion.envCode" class="alert alert-danger">
            <p-message severity="success" text="Current Environmental Region: '{{envRegion.envCode}}'"></p-message>
        </div>
    </div>
</div> 

 <!-- Selection criteria  -->

<div class="grid col-8">
    <div class="col-1">
        <label for="selectedUserName" class="margin-left">Username: </label>
        <input pInputText id="userName" [(ngModel)]="selectedUserName" placeholder="Username:"/> 
    </div>  
    <div class="col-1"></div>
    <div class="col-1">
        <label for="selectedBrandCode" class="margin-left">Brand Code: </label>
        <p-select id ="brandCode" [options]="brandCodes" [(ngModel)]="selectedBrandCode" [filter]="true" 
            placeholder="Brand Code:" [editable]="false" ></p-select>
    </div>  
    <div class="col-1"></div>
    <div class="col-1">
        <label for="selectedRoleName" class="margin-left">Role Name: </label>
        <p-select id ="roleName" [options]="roleNames" [(ngModel)]="selectedRoleName" [filter]="false" 
            placeholder="Role Name:" [editable]="false"></p-select>
    </div>  
    <div class="col-1"></div>
    <div class="col-1">
        <p-button label="Search" styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" (click)="onSearchClick($event)"></p-button>
    </div>  
    <div class="col-1">
        <p-button label="Next" styleClass="p-button-primary wal-primary p-button-raised p-button-rounded margin-left" (click)="onNextClick($event)"></p-button>
    </div>  
    <div class="col-1">
        <p-button label="Clear" styleClass="p-button-danger wal-danger p-button-raised p-button-rounded margin-left" (click)="onClearClick($event)"></p-button>
    </div>  
    <div class="col-1">
    </div>  
    <div class="col-2">
        <button pButton type="button" label="Env. Region" icon="pi pi-sitemap" iconPos="left" (click)="onEnvRegionClick($event)"  class="p-button-raised p-button-rounded"></button>
    </div>  

</div>

 <!-- Grid with all users based on the specified selection criteria  -->

<div class="grid">
    <div class="col-8">

        <p-table #dt [columns]="cols" [value]="users" selectionMode="single" [(selection)]="selectedUser" 
            class="wal-table" sortMode="multiple" (onRowSelect)="onRowSelect($event)" 
            [paginator]="true" [rows]="15" [rowsPerPageOptions]="[10,15,25,50]" 
            [showCurrentPageReport]="true">
          <ng-template pTemplate="caption">
              List of Users
          </ng-template>
          <ng-template pTemplate="header" let-columns>
              <tr>
                    @for (col of columns; track col.field) {
                        <th [pSortableColumn]="col.field"
							[style.display]="col.display"
                            [style.width]="col.width">
                            {{ col.header }}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
                    }
            </tr>
              <tr>

                    @for (col of columns; track col.field) {
                        <th [style.width]="col.width">
                            @switch (col.field) {
                                @case ('userId') {
                                    <input pInputText type="text" [style.width]="'100%'"
                                        (input)="dt.filter(($any($event.target)).value, col.field, 'contains')"
                                    />
                                }
                                @case ('userName') {
                                    <input pInputText type="text" [style.width]="'100%'"
                                        (input)="dt.filter(($any($event.target)).value, col.field, 'contains')"
                                    />
                                }
                                @case ('brandCode') {
                                    <input pInputText type="text" [style.width]="'100%'"
                                        (input)="dt.filter(($any($event.target)).value, col.field, 'contains')"
                                    />
                                }
                                @default {
                                }
                            }
                        </th>
                    }

            </tr>  
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr [pSelectableRow]="rowData">
                        @for (col of columns; track col.field) {
                            <td [style.width]="col.width" [style.display]="col.display">
                                {{ rowData[col.field] }}
                            </td>
                        }
              </tr>
          </ng-template>
          <ng-template pTemplate="summary" let-rowData>
              <div style="text-align:left" *ngIf="isSubmitShown">
                  <p-button label="Add" styleClass="p-button-info wal-info p-button-raised p-button-rounded margin-left" (click)="showDialogToAdd()"></p-button>
              </div>
          </ng-template>    
          </p-table> 
      
    </div>
</div>

<!-- User Details dialog -->

<p-confirmDialog class="lf-confirm-dialog" appendTo="body"></p-confirmDialog>

<p-dialog appendTo="body" header="User Details" [(visible)]="displayDialog" [focusOnShow]="false" [responsive]="true"
        styleClass="wal-dialog"
        showEffect="fade" [modal]="true"  [style]="{width: '40%'}">
    <div *ngIf="user">

        <p-tabs class="wal-tabs" [(value)]="tabIndex">

          <p-tablist>

            <p-tab [value]="'Properties'">
              <span class="tab-label">
                <i class="pi pi-user-edit" aria-hidden="true"></i>
                <span class="ml-2">Properties</span>
              </span>
            </p-tab>

            <p-tab [value]="'Roles'">
              <span class="tab-label">
                <i class="pi pi-check-circle" aria-hidden="true"></i>
                <span class="ml-2">Roles</span>
              </span>
            </p-tab>

          </p-tablist>  

          <p-tabpanels>

            <p-tabpanel [value]="'Properties'">


                <div class="grid">
                    <div class="col-1"></div>
                    <div class="field grid">
                        <label for="userId" class="col-fixed label" style="width: 12em">User Id:</label>
                        <div class="col">
                            <input pInputText id="userId" [(ngModel)]="user.userId" autofocus [disabled]="true" style="width: 8em"/>
                        </div>
                    </div>
                    <div class="col-1"></div>
                    <div class="field grid">
                        <label for="userName" class="col-fixed label" style="width:12em">Username:</label>
                        <div class="col">
                            <input pInputText id="userName" [(ngModel)]="user.userName" style="width: 10em">
                        </div>
                    </div>
                </div> 

                <div class="grid">
                    <div class="col-1"></div>
                    <div class="field grid">
                        <label for="brandCode" class="col-fixed label" style="width: 12em">Brand Code:</label>
                        <div class="col">
                            <p-select id ="brandCode" [options]="brandCodes" [(ngModel)]="user.brandCode" [filter]="true" 
                                placeholder="Select brand" [editable]="false"  [style]="{width: '8em'}"></p-select>
                        </div>
                    </div>
                    <div class="col-1"></div>
                    <div class="field grid">
                        <label for="password" class="col-fixed label" style="width:12em">Password:</label>
                        <div class="col">
                            <input pPassword type="password" id="password" [(ngModel)]="user.password"/>
                        </div>
                    </div>
                </div> 

                <div class="grid">
                    <div class="col-1"></div>
                    <div class="field grid">
                        <label for="locked" class="col-fixed label" style="width: 12em">Locked:</label>
                        <div class="col">
                            <p-checkbox [(ngModel)]="user.locked" id="locked" [binary]="true"></p-checkbox>
                        </div>
                    </div>
                    <div class="col-2"></div>
                    <div class="field grid">
                        <label for="disabled" class="col-fixed label" style="width:12em">Disabled:</label>
                        <div class="col">
                            <p-checkbox [(ngModel)]="user.disabled" id="disabled" [binary]="true"></p-checkbox>
                        </div>
                    </div>
                </div> 

                <div class="grid">
                    <div class="col-1"></div>
                    <div class="field grid">
                        <label for="lastLoginDate" class="col-fixed label" style="width:12em">Last Login:</label>
                        <div class="col">
                            <input pInputText id="lastLoginDate" [(ngModel)]="user.lastLoginDate" [disabled]="true"/>
                        </div>
                    </div>
                </div> 

            </p-tabpanel>

            <p-tabpanel [value]="'Roles'">

                <p-pickList [source]="availableRoles" [target]="grantedRoles" 
                    sourceHeader="Available" targetHeader="Granted" class="wal-picklist"
                    [responsive]="true" [dragdrop]="true" [showSourceControls]="false" [showTargetControls]="false">
                <ng-template let-role pTemplate="item">
                <div class="ui-helper-clearfix">
                    <div>{{role.label}}</div>
                </div>
                </ng-template>
                </p-pickList>

            </p-tabpanel>

          </p-tabpanels>        

        </p-tabs>

    </div>

    <ng-template #footer>
        <div class="footer-actions">
            <p-button label="Delete" styleClass="p-button-danger wal-danger p-button-raised p-button-rounded margin-left" (click)="delete()" *ngIf="isSubmitShown"></p-button>
            <p-button label="Save" styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" (click)="save()" *ngIf="isSubmitShown"></p-button>
            <p-button label="Cancel" styleClass="p-button-primary wal-primary p-button-raised p-button-rounded margin-left" (click)="cancel()"></p-button>
  
        </div>
    </ng-template>
</p-dialog>

<!-- The following is a popup dialog to select an enviromental region -->

<p-dialog appendTo="body" header="Select Enviromental Region" [(visible)]="displayEnvRegionDialog" [focusOnShow]="false" 
        [responsive]="true" styleClass="wal-dialog"
        showEffect="fade" [modal]="true"  [style]="{width: '35%'}" [showHeader]="true">

        <div class="grid">
            <div class="col-12">
        
                <p-table #dt [columns]="envRegionCols" [value]="envRegions" selectionMode="single" 
                    [(selection)]="envRegion"  
                    sortMode="multiple" (onRowSelect)="onRowEnvRegionSelect($event)" [paginator]="false" [rows]="10" >
                  <ng-template pTemplate="header" let-columns>
                      <tr>
						@for (col of columns; track col.field) {
							<th [pSortableColumn]="col.field"
								[style.display]="col.display"
								[style.width]="col.width">
								{{ col.header }}
								<p-sortIcon [field]="col.field"></p-sortIcon>
							</th>
						}
                  </ng-template>
                  <ng-template pTemplate="body" let-rowData let-columns="columns">
                      <tr [pSelectableRow]="rowData">
                        @for (col of columns; track col.field) {
                            <td [style.width]="col.width" [style.display]="col.display">
                                {{ rowData[col.field] }}
                            </td>
                        }
                      </tr>
                  </ng-template>
                </p-table> 
              
            </div>
        </div>

    <ng-template #footer>
        <div class="footer-actions">
            <p-button label="Select" styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" (click)="onEnvRegionSelect()"></p-button>
            <p-button label="Cancel" styleClass="p-button-primary wal-primary p-button-raised p-button-rounded margin-left" (click)="onCancelEnvRegionSelect()"></p-button>

        </div>
    </ng-template>

</p-dialog>


